import { initClientAuth } from "@packages/auth/client";
import { env } from "~/env";

export const authClient = initClientAuth({
  baseURL: env.VITE_SERVER_URL,
});
